import React from 'react'

import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 24
}

/**
 * Stateless function representing the ic-school icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <SchoolIcon width={24} />
 */
const SchoolIcon = props => (
    <SvgIcon {...props}>
        <path d="M19.001 13.15V16.25C18.9837 16.5478 18.8946 16.8371 18.7414 17.093C18.5882 17.349 18.3753 17.5641 18.121 17.72L12.881 20.53C12.6054 20.6585 12.305 20.725 12.001 20.725C11.6969 20.725 11.3966 20.6585 11.121 20.53L5.88098 17.72C5.62664 17.5641 5.41378 17.349 5.26055 17.093C5.10732 16.8371 5.01827 16.5478 5.00098 16.25V13.15L11.121 16.52C11.3934 16.6532 11.6927 16.7225 11.996 16.7225C12.2993 16.7225 12.5985 16.6532 12.871 16.52L19.001 13.15ZM22.481 8.67002L12.86 3.47002C12.5854 3.33853 12.2849 3.27026 11.9805 3.27026C11.6761 3.27026 11.3755 3.33853 11.101 3.47002L2.72998 8.04002C1.75998 8.56002 1.75998 9.43002 2.71998 9.97002L11.11 14.63C11.383 14.7664 11.6848 14.835 11.99 14.83C12.295 14.8337 12.5965 14.7652 12.87 14.63L21.001 10.11V16C21.001 16.2652 21.1063 16.5196 21.2939 16.7071C21.4814 16.8947 21.7358 17 22.001 17C22.2662 17 22.5205 16.8947 22.7081 16.7071C22.8956 16.5196 23.001 16.2652 23.001 16V9.53002C22.9984 9.3533 22.9488 9.18045 22.8572 9.02929C22.7657 8.87812 22.6354 8.75411 22.48 8.67002H22.481Z" />
    </SvgIcon>
)

SchoolIcon.defaultProps = defaultProps

export { SchoolIcon }
